module.exports = __webpack_public_path__ + "img/history_btn.243f237b.png";